import {Grow} from "@mui/material";
import Box from "@mui/material/Box";
import {Bar, Radar} from "react-chartjs-2";
import React from "react";
import {ArcElement, Chart, Filler, Legend, LineElement, PointElement, RadialLinearScale, Tooltip} from "chart.js";
import PluginService from "chart.js/dist/core/core.plugins";

Chart.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
);

export default function GenericRadarChart(props:{
    data: any[],
    mainLabel: string;
    getValue: (item: any) => number,
    getComparisonValue?: (item: any) => number,
    comparisonLabel?: string,
    labels: (item: any) => string | number,
    rollingAverageWindow? : number,
    vertical?: boolean
}){

    const options = {
        responsive: true,
        scale: {
            r: {
                min: 0,
                max: 0.7,
            },
            y: {
                grid: {
                    color: 'red',
                },
            }
        }
    };

    let datasets = [
        {
            label: props.mainLabel,
            data: props.data.map(props.getValue),
            backgroundColor: "rgba(0, 255, 255, 0.5)",
            borderColor: "rgba(0, 255, 255, 0.5)",
            fill: true
        },
    ]

    if(props.getComparisonValue && props.comparisonLabel){
        const comparison_dataset = {
            label: props.comparisonLabel,
            data: props.data.map(props.getComparisonValue),
            backgroundColor: "rgba(190, 82, 42, 0.5)",
            borderColor: "rgba(190, 82, 42, 0.5)",
            fill: true
        }
        datasets.push(comparison_dataset);
    }

    const data = {
        labels:  props.data.map(props.labels),
        datasets: datasets
    };

    return (
        <Grow in={true} style={{ transformOrigin: "0 -50 0" }} {...{ timeout: 2000 }}>
            <Box
                sx={{
                    width: "100%",
                    height: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                }}
            >
                {/* @ts-ignore*/}
                <Radar options={options} data={data} />
            </Box>
        </Grow>
    );

}